import script from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSelect.vue?vue&type=script&setup=true&lang=js"

import "./BaseSelect.vue?vue&type=style&index=0&id=0bdc249d&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bdc249d"]])

export default __exports__